import { useEffect, useRef, useState } from 'preact/hooks';
import style from './TextField.css';
import ErrorFilledIcon from '../Icons/ErrorFilledIcon';
import { renderIf } from '../../../utils/render.utils';
import { _className } from '../../../utils/classname.utils';

export default function TextField({
  label,
  placeholder = '',
  helperText = '',
  className = '',
  hasError = false,
  type = 'text',
  ...props
}) {
  const inputElement = useRef();
  const [focused, setIsFocused] = useState(false);

  useEffect(() => {
    if (focused === true) {
      inputElement.current.scrollIntoView({ block: 'center' });
    }
  }, [focused]);

  return (
    <div
      className={`
        ${className}
        ${style['text-input']}
        ${_className(focused, style.focused)}
        ${_className(!!placeholder || !!props.value, style['has-value'])}
        ${_className(hasError, style['has-error'])}
        ${_className(props.disabled, style['disabled'])}
      `}
      onClick={() => inputElement.current.focus()}
    >
      <div className={style['text-input-inner']}>
        <div className={style.content}>
          <label>{label}</label>
          <input
            {...props}
            placeholder={placeholder}
            ref={inputElement}
            type={type}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
        </div>

        <ErrorFilledIcon
          width={24}
          height={24}
          variant="error"
          className={style['error-icon']}
        />
      </div>

      {renderIf(
        helperText,
        <span className={`${style['input-helper']}`}>{helperText}</span>,
      )}
    </div>
  );
}
